import Vue from "vue";
Vue.directive("message", {
  bind: function (el, binding, vnode) {},
  update: function (el, binding, vnode, oldVnode) {
    if (!el.parentElement) return;
    const msgDivList = el.parentElement.getElementsByClassName("msg_div");
    if (
      binding.value &&
      binding.value.text &&
      binding.value.text != "RepeatRequest"
    ) {
      let a = msgDivList && msgDivList.length ? msgDivList[0] : null;
      if (!a) {
        a = document.createElement("div");
        a.className = "msg_div";
        el.parentElement.insertBefore(a, el);
        //  el.parentElement.style["overflow-y"] = "auto";
        el.style.height = "calc(100% - 64px)";
      }
      a.parentElement.style["flex-wrap"] = "wrap";
      a.innerHTML =
        "<div class='msg_ msg_" +
        binding.value.type +
        "'>" +
        binding.value.text +
        "</div>";
      //  el.style.display = "none";
    } else {
      Array.from(msgDivList).forEach(div => {
        if (div.parentNode === el.parentNode) {
          div.remove();
        }
      })
      // el.style.display = "block";
    }
  },
  componentUpdated: function (el, binding, vnode, oldVnode) {
    setTimeout(() => {
      if (el.children[0] && el.children[0].classList.contains("echarts") && el.children[0].__vue__) {
        el.children[0].__vue__.chart.resize(el.style.width, el.style.height);
      }
    }, 0);
  },
});
